import './stepper.scss';

import { Stepper as MantineStepper } from '@eliberty/design-system-react/mantine';

export interface StepItem {
  allowStepSelect?: boolean;
  description?: string;
  icon?: React.ReactNode;
  id: string;
  label: React.ReactNode;
}

interface StepperProps {
  active: number;
  onStepClick?: (stepIndex: number) => void;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  steps: StepItem[];
}

const stepperClassNames = {
  root: 'eliberty-Stepper-root',
  separator: 'eliberty-Stepper-separator',
  step: 'eliberty-Stepper-step',
  stepBody: 'eliberty-Stepper-stepBody',
  stepDescription: 'eliberty-Stepper-stepDescription',
  stepIcon: 'eliberty-Stepper-stepIcon',
  stepLabel: 'eliberty-Stepper-stepLabel',
  steps: 'eliberty-Stepper-steps',
};

const Stepper = ({ active, onStepClick, size = 'sm', steps }: StepperProps) => (
  <MantineStepper
    active={active}
    classNames={stepperClassNames}
    onStepClick={onStepClick}
    size={size}
  >
    {steps.map((step) => (
      <MantineStepper.Step
        allowStepSelect={step.allowStepSelect}
        description={step.description}
        icon={step.icon}
        key={step.id}
        label={step.label}
      />
    ))}
  </MantineStepper>
);

export default Stepper;
